import { Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TaskAcknowledgementRequiredPanelComponent } from '@app/components/task/task-acknowledgement-required-panel/task-acknowledgement-required-panel.component';
import { TaskPrioritySelectComponent } from '@app/components/task/task-priority-select/task-priority-select.component';
import { LocationSelectComponent } from '@app/components/task/task-state-selectors/location-select/location-select.component';
import { TaskEstimationSelectComponent } from '@app/components/task/task-state-selectors/task-estimation-select/task-estimation-select.component';
import { TaskIndustrySelectComponent } from '@app/components/task/task-state-selectors/task-industry-select/task-industry-select.component';
import { TaskStatusSelectComponent } from '@app/components/task/task-state-selectors/task-status-select/task-status-select.component';
import {
  TaskTimerComponent,
  TaskTimerMode
} from '@app/components/task/task-state-selectors/task-timer/task-timer.component';
import { TagComponent } from '@app/shared/components/tag/tag.component';
import { AvatarSize } from '@app/shared/types/enums/avatar-size.enum';
import { TaskPriority } from '@app/shared/types/enums/task-priority.enum';
import { TaskStatus } from '@app/shared/types/enums/task-status.enum';
import { ProjectParticipant } from '@app/shared/types/models/project/project-participant';
import { Tag } from '@app/shared/types/models/tag/tag.model';
import { TaskEstimation } from '@app/shared/types/models/task/task-estimation';
import { TaskStatusSelectEnum } from '@app/shared/types/models/task/task-status.model';
import { Task } from '@app/shared/types/models/task/task.model';
import { UiDatePickerCompactComponent } from '@app/shared/ui/date-picker-compact/ui-date-picker-compact.component';
import { UiSliderComponent } from '@app/shared/ui/slider/ui-slider.component';
import { UiTaskAssigneesComponent } from '@app/shared/ui/task-assignees/ui-task-assignees.component';
import { formatPercentageValue } from '@app/shared/utils/percentage-format.util';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * PROPOZYCJA — DO WERYFIKACJI: wide metadata renderer, using existing field controls.
 * The metadata controller owns reads and actions; this component only renders inputs and emits requests.
 */
@Component({
  selector: 'proffeo-task-details-wide-metadata',
  templateUrl: './task-details-wide-metadata.component.html',
  styleUrl: './task-details-wide-metadata.component.scss',
  host: { class: 'block min-w-0 max-w-full' },
  imports: [
    MatIconModule,
    TaskStatusSelectComponent,
    TaskPrioritySelectComponent,
    TranslatePipe,
    UiDatePickerCompactComponent,
    UiSliderComponent,
    TaskIndustrySelectComponent,
    LocationSelectComponent,
    TagComponent,
    TaskEstimationSelectComponent,
    TaskTimerComponent,
    TaskAcknowledgementRequiredPanelComponent,
    UiTaskAssigneesComponent
  ]
})
export class TaskDetailsWideMetadataComponent {
  protected readonly TaskStatusSelectEnum = TaskStatusSelectEnum;
  protected readonly AvatarSize = AvatarSize;
  protected readonly taskTimerMode = TaskTimerMode;
  protected readonly formatPercent = formatPercentageValue;

  public readonly task = input.required<Task>();
  public readonly tags = input.required<Tag[]>();
  public readonly taskUsers = input.required<ProjectParticipant[]>();

  public readonly statusSelected = output<TaskStatus>();
  public readonly progressSelected = output<number>();
  public readonly prioritySelected = output<TaskPriority>();
  public readonly industryRequested = output<void>();
  public readonly locationRequested = output<void>();
  public readonly openTimeReportRequested = output<void>();
  public readonly timeReportsTabRequested = output<void>();
  public readonly startDateSelected = output<Date | null>();
  public readonly endDateSelected = output<Date | null>();
  public readonly estimationSelected = output<TaskEstimation>();
  public readonly groupRequested = output<void>();
  public readonly participantsRequested = output<void>();
  public readonly tagsRequested = output<void>();
}
